module.exports = new __parcel__URL__("rajbhasha.90207481.webp").toString();